import React from "react";
import QuoteStepBase from '../../components/QuoteStepBase'
import { Alert } from 'react-bootstrap'
import { IQuoteStepState, IQuoteStepComponentProps } from "../../components/interfaces";
import { QuoteStep } from "./QuoteStepLayout";
import { connect } from "react-redux";
import { FULL_QUOTE_STEPS } from "../../AppConstants";
import { IAppState, IOffline } from "../../state/interfaces";
import { IPaths } from "../../classes/Domain";
import QuoteActions from "../../state/appActions";

interface IState extends IQuoteStepState {
}

interface IProps extends IQuoteStepComponentProps {
    offlineData: IOffline,
    PATHS: IPaths;
}

class Offline extends QuoteStepBase<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            updatingStore: false,
            errors: null
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    render() {
        return (
            <QuoteStep id="offline" className="policy-details">
                <div>
                    <Alert variant={"danger"}>
                        <p><strong className="text-uppercase">Sorry! Can not process your quote!</strong></p>
                        <p>Please review information below</p>
                        <ul>
                            <p className="text-uppercase">
                                {this.props.offlineData.message}
                            </p>
                        </ul>
                    </Alert>
                </div>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState) => {
    return {
        offlineData: state.appOfflineData
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(FULL_QUOTE_STEPS.OFFLINE))
    };
};

export default connect(mapProps, mapDispatch)(Offline);
